import React from "react";
import "./dashboard.css";

// Small building blocks shared by the dashboard pages

export function PageHeader({ title, lead, actions }) {
  return (
    <div className="dash-page-header">
      <div>
        <h1 className="dash-page-title">{title}</h1>
        {lead && <p className="dash-page-lead">{lead}</p>}
      </div>
      {actions && <div>{actions}</div>}
    </div>
  );
}

export const STATUS_LABELS = {
  initiated: "En attente de paiement",
  paid: "Payée",
  in_progress: "En cours",
  fulfilled: "Terminée",
  failed: "Échouée",
};

export function StatusBadge({ status, label }) {
  return (
    <span className={`dash-badge is-${status || "initiated"}`}>
      {label || STATUS_LABELS[status] || status || "—"}
    </span>
  );
}

export function EmptyState({ title, children }) {
  return (
    <div className="dash-empty">
      <strong>{title}</strong>
      {children}
    </div>
  );
}

// Card of a request or ticket in the client space
export function ItemCard({ title, meta, status, statusLabel, actions }) {
  return (
    <article className="dash-item">
      <div className="dash-item-top">
        <h3 className="dash-item-title">{title}</h3>
        <StatusBadge status={status} label={statusLabel} />
      </div>
      <p className="dash-item-meta">{meta}</p>
      {actions && <div className="dash-item-actions">{actions}</div>}
    </article>
  );
}
